import React, { useEffect, useState } from 'react'
import CardLoadingPage from '../../components/CardLoadingPage/CardLoadingPage';
import CustomModal from '../../components/CustomModal/CustomModal';
import CreateSedeForm from '../../components/Forms/CreateSedeForm/CreateSedeForm';
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomTable from '../../components/CustomTable/CustomTable';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import useSedi from '../../hooks/useSedi';
import { alertService } from '../../services/AlertService';
import UtilityService from '../../services/UtillityServices/UtilityService';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import { ACTION_TYPES } from '../../model/actions';
import useSediConfigTable from '../../configTable/useSediConfigTable';
import SedeInfo from '../../components/SedeInfo/SedeInfo';

const GestioneSediPage = () => {
  const {
    getSediByParams,
    loadingStateSedi,
    createSede, 
    deleteSede,
    modalStateSedi,
    setModalStateSedi,
    updateSede,
  } = useSedi();

  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const [sedi, setSedi] = useState([]);
  const [selectedSede, setSelectedSede] = useState(null);
  const [formCreateSede, setFormCreateSede] = useState({});

  const [orderBy, setOrderBy] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1); 
  const [formDataFilter, setFormDataFilter] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingSedi, setIsLoadingSedi] = useState(false);
  const sediConfigTable = useSediConfigTable();

  useEffect(() => {
    if (!isLoadingSedi) {
      printAllSedi();
    }
  }, [orderBy, orderType, selectedPage]);
  
  const fetchSedi = async (obj) => {
    setIsLoadingSedi(true);
  
    obj = {
      ...obj,
      filtri: {
        ...obj.filtri,
      }
    };
  
    const fetchSediList = await getSediByParams(obj);
    const countPagination = Math.ceil(fetchSediList?.count / obj.limite);
    let sediList = fetchSediList?.data ?? [];
    setTotalPages(countPagination);
    setSedi(sediList);
    setIsLoadingSedi(false);
    if(sediList?.length === 0){
      setSelectedPage(1)
    }
  }
  
  const printAllSedi = async () => {
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: `${orderBy ?? "descrizione"} ${orderType ?? "asc"}`
    };
  
    await fetchSedi(obj);
  };
  
  const onFilteredTable = async () => {
    setSelectedPage(1);
  
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: 1,
      ordinamento: `${orderBy ?? "descrizione"} ${orderType ?? "asc"}`
    };
  
    await fetchSedi(obj);
  };

  const openInfoModal = (sede) => {
    setSelectedSede(sede)
    setModalStateSedi(state => ({ ...state, showModalInfoSede: true }));
  }

  const openEditModal = (sede) => {
    setSelectedSede(sede)
    setFormCreateSede(sede);
    setModalStateSedi(state => ({ ...state, showModalUpdateSede: true }));
  }

  const openDeleteModal = (sede) => {
    setSelectedSede(sede)
    setModalStateSedi(state => ({ ...state, showModalDeleteSede: true }));
  }

  const handleCloseModal = () => {
    setModalStateSedi(state => ({ 
       ...state,
       showModalCreateSede: false, 
       showModalInfoSede: false, 
       showModalDeleteSede: false,
       showModalUpdateSede: false,
      }));
  }

  const openModalCreateSede = () => {
    setModalStateSedi(state => ({ ...state, showModalCreateSede: true }));
  }

  const renderSelectedDeleteSede = () => {
    return (
      <>
      <span className="d-block fs-4 mb-2"><b>Vuoi eliminare la seguente sede?</b> </span>
      <span className="d-block fs-5">{selectedSede?.descrizione}</span>
      </>
    )
  }

  const onCreateSede = async () => {
    const requiredFields = ["descrizione"];
    const missingFields = UtilityService.validationForm(formCreateSede, requiredFields);
    if (missingFields?.length > 0) {
        alertService.warn(`I seguenti campi sono obbligatori: ${missingFields}`, {autoClose: true});
        return;
    }

  const res = await createSede(formCreateSede);
    if(res) {
      printAllSedi();
    }

  };

  const onDeleteSede = async () => {
    const obj = {id_sede: selectedSede?.id_sede}
    const res = await deleteSede(obj);
    if(res) {
      printAllSedi();
    }
  }

  const onUpdateSede = async () => {
    const obj = {
      ...formCreateSede,
      id_sede: selectedSede?.id_sede
    }
    const res = await updateSede(obj);
    if(res) {
      printAllSedi();
    }
  }

  const handleOrder = (orderBy, orderType) => {
    setOrderBy(orderBy);
    setOrderType(orderType);
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
  };

  const actions = [
    {
      label: ACTION_TYPES.DETAILS,
      icon: 'bi-info-circle text-dark',
      tooltip: ACTION_TYPES.DETAILS,
      type: ACTION_TYPES.VIEW,
      condition: () => true,
      onClick: (sede) => openInfoModal(sede)
    },
    {
      label: ACTION_TYPES.UPDATE,
      icon: 'bi-pencil-fill text-warning',
      tooltip: ACTION_TYPES.UPDATE,
      type: ACTION_TYPES.MANAGER,
      condition: () => true,
      onClick: (sede) => openEditModal(sede)
    },
    {
      label: ACTION_TYPES.DELETE,
      icon: 'bi-trash-fill text-danger',
      tooltip: ACTION_TYPES.DELETE,
      type: ACTION_TYPES.MANAGER,
      condition: () => true,
      onClick: (sede) => openDeleteModal(sede)
    }
  ];

  return (
    <>
        <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`} style={{minHeight: '700px'}}>
            <div className='container'>
              <div className='d-flex justify-content-between custom-card-header'>
                <div className='d-flex gap-3 custom-card-title my-2'>
                  <div className={`custom-icon-container`}>
                    <i className={`bi custom-icon bi-building fs-2`}></i>
                  </div>
                  <div className='align-self-center'>
                    <span className='fs-4 d-block'><i><b>Gestione sedi</b></i></span>
                  </div>
                </div>
                <div className='align-self-center my-2'>
                  <button type='button' className='btn btn-primary' onClick={openModalCreateSede}>Crea sede</button>
                </div>
              </div>
              <div className='mt-5'>
                <CustomFilterTable 
                  formDataFilter={formDataFilter}
                  setFormDataFilter={setFormDataFilter}
                  onFilteredTable={onFilteredTable}
                  isLoadingData={loadingStateSedi.isLoadingSediByParams}
                  searchNodeType={[
                    {nodeType: "input", name: "descrizione", placeholder: "Indirizzo"},
                  ]}
                />
              </div>
              {  !loadingStateSedi.isLoadingSediByParams ? ( 
                  <>
             {(!sedi || sedi?.length === 0) ? (
                    <div className='mt-5 pt-5 text-center'>
                        <p>Non ci sono sedi da mostrare.</p>
                    </div>) : (
                      <>
              <CustomTable
                data={sedi}
                actions={actions}
                columns={sediConfigTable}
                handleOrder={handleOrder}
                orderBy={orderBy}
                orderType={orderType}
              />
              <div className="d-flex justify-content-end mt-1">
                <CustomPagination
                  totalPages={totalPages}
                  selectedPage={selectedPage}
                  handlePageChange={handlePageChange}
                />
              </div>
                      </>

                    )}
                  </>
              ) : (
                <LoadingTable loadingCol={2} />
              ) }
              <>
              </>
            </div>
        </div>
         <CustomModal
          show={modalStateSedi.showModalCreateSede}
          onHide={handleCloseModal}
          headerText="Crea sede"
          size={"md"}
          btnText={"Crea sede"}
          body={<CreateSedeForm 
            formCreateSede={formCreateSede}
            setFormCreateSede={setFormCreateSede}
            showModalCreateSede={modalStateSedi.showModalCreateSede}
          />} 
          isLoading={loadingStateSedi.isLoadingSedeCreating}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onCreateSede} 
        />
         <CustomModal
          show={modalStateSedi.showModalUpdateSede}
          onHide={handleCloseModal}
          headerText="Modifica sede"
          size={"md"}
          btnText={"Salva modifiche"}
          body={<CreateSedeForm 
            formCreateSede={formCreateSede}
            setFormCreateSede={setFormCreateSede}
            showModalCreateSede={modalStateSedi.showModalUpdateSede}
          />} 
          isLoading={loadingStateSedi.isLoadingSedeUpdate}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onUpdateSede} 
        />
         <CustomModal
          show={modalStateSedi.showModalDeleteSede}
          onHide={handleCloseModal}
          headerText="Elimina sede"
          size={"md"}
          variant={"danger"}
          btnText={"Elimina"}
          body={renderSelectedDeleteSede()} 
          isLoading={loadingStateSedi.isLoadingSedeDelete}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onDeleteSede} 
        />
         <CustomModal
          show={modalStateSedi.showModalInfoSede}
          onHide={handleCloseModal}
          headerText="Informazioni sede"
          size={"md"}
          hideSaveBtn={true}
          body={<SedeInfo sedeData={selectedSede} />} 
          closeButton={true}
          onUndoChanges={handleCloseModal}
        />
      </>
  )

}

export default GestioneSediPage;